export const API_ROUTES = {
  USERS: {
    ME: '/users/me',
  },
  PROFILE: {
    UPDATE: '/profile',
  },
  CONNECT: {
    ACCOUNTS_ME: '/connect/accounts/me',
    ACCOUNTS: '/connect/accounts',
    ACCOUNT_LINKS: '/connect/account-links',
    ACCOUNTS_SYNC: '/connect/accounts/sync',
    ACCOUNTS_DASHBOARD: '/connect/accounts/dashboard',
    EXTERNAL_ACCOUNTS: '/connect/external-accounts',
  },
} as const;
